import * as $ from "jquery"

const setOutSideFormField = (tag: string, value: string) => $(`#${tag}`).val(value)

export {
  setOutSideFormField,
}